/* hs-eslint ignored failing-rules */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState, useCallback } from 'react';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import H2 from 'UIComponents/elements/headings/H2';
import H5 from 'UIComponents/elements/headings/H5';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UIAlert from 'UIComponents/alert/UIAlert';
import AdwordsExitModal from 'ads-account-connection/components/ad-accounts/AdwordsExitModal';
import AdwordsStepIndicators from 'ads-account-connection/components/ad-accounts/AdwordsStepIndicators';
import { ACCOUNT_SETUP_ORDER, ACCOUNT_SETUP_STEPS } from 'ads-account-connection/lib/AdwordsSetupStatus';
import AdAccountCreationData from 'ads-account-connection/data/AdAccountCreationData';
import Networks from 'ads-account-connection/lib/Networks';

const AdwordsAdAccountBillingSetup = ({
  onCancel,
  currentStep,
  onStepChange,
  inviteLink,
  networkUserId,
  adAccountId,
  refetchAccounts,
  trackEvent,
  isDeveloperPortal
}) => {
  const [showConfirmExitModal, setShowConfirmExitModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const onExitSetup = useCallback(showExitModal => {
    setShowConfirmExitModal(showExitModal);
  }, []);
  const validateSetup = useCallback(() => {
    setLoading(true);
    AdAccountCreationData.validateAdwordsSetup(adAccountId, networkUserId).then(response => {
      if (response.accountSetUp && response.errors.length === 0) {
        refetchAccounts();
        onStepChange(ACCOUNT_SETUP_STEPS.SETUP_COMPLETE);
        trackEvent('accountCreationAction', {
          action: 'Clicked the billing step button and verified',
          network: Networks.ADWORDS
        });
      } else {
        trackEvent('accountCreationAction', {
          action: 'Clicked the billing step button and failed verification',
          network: Networks.ADWORDS,
          errorType: response.errors.toString()
        });
      }

      setErrors(response.errors);
    }).catch(err => {
      const errorType = err.responseJSON.errorType;

      if (errorType) {
        setErrors([errorType]);
      }
    }).finally(() => {
      setLoading(false);
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }, [adAccountId, networkUserId, onStepChange, refetchAccounts, trackEvent]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => onExitSetup(true)
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(AdwordsStepIndicators, {
        stepIndex: ACCOUNT_SETUP_ORDER.indexOf(currentStep)
      }), /*#__PURE__*/_jsxs("div", {
        className: "p-x-6 text-center",
        children: [/*#__PURE__*/_jsx(H5, {
          className: "m-top-4 m-bottom-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.setupBillingTitle"
          })
        }), !isDeveloperPortal && /*#__PURE__*/_jsx(UIHelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.tooltip"
          }),
          tooltipPlacement: "right",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.setupBillingBody"
          })
        }), errors.length > 0 && errors.map(error => /*#__PURE__*/_jsx(UIAlert, {
          className: "m-top-4 m-bottom-2",
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.${error}.title`
          }),
          type: "danger",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.${error}.description`
          })
        }, error)), /*#__PURE__*/_jsxs(UIList, {
          ordered: true,
          styled: true,
          align: "left",
          className: "m-top-4",
          children: [/*#__PURE__*/_jsx(UILink, {
            external: true,
            href: inviteLink,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.billingSetupLink"
            })
          }), isDeveloperPortal ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.devPortalSetupBillingBody"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.billingSetupButton"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "right",
      children: /*#__PURE__*/_jsx(UILoadingButton, {
        use: "primary",
        onClick: validateSetup,
        loading: loading,
        failed: errors.length > 0,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.billingSetupButton"
        })
      })
    }), showConfirmExitModal && /*#__PURE__*/_jsx(AdwordsExitModal, {
      onConfirm: onCancel,
      onReject: () => onExitSetup(false)
    })]
  });
};

export default AdwordsAdAccountBillingSetup;